/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Import_File_TitleInputs */



/**
* | output |
* | --- |
* | "Import File" |
*
* @param {Toolbar_Secondary_Import_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_import_file_title = /** @type {((inputs?: Toolbar_Secondary_Import_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Import_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer un Fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importdatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de importação")
	return /** @type {LocalizedString} */ ("Import File")
});